import { render, staticRenderFns } from "./wxpay_app.vue?vue&type=template&id=3ef141ca&scoped=true"
import script from "./wxpay_app.vue?vue&type=script&lang=js"
export * from "./wxpay_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef141ca",
  null
  
)

export default component.exports